import { Link } from 'react-router-dom';
import Background from '../assets/images/background.jpg';
import { AttributeCard } from './AttributeCard';
import pricing from '../assets/images/Vector.svg';
import verified from '../assets/images/Vector1.svg'
import tracking from '../assets/images/Vector2.svg'
import Arrow from '../assets/images/arrow.svg'
import FooterBg from '../assets/images/Frame 21.png'
import { useMobile } from '../hooks/useMobile';

interface AuthLayoutProps {
    directory: string;
    showBackLink?: boolean;
    children: React.ReactNode;
}

export const AuthLayout = ( { children, directory, showBackLink = false }: AuthLayoutProps ) => {
const isMobile = useMobile();
    
    return (
    <section style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
        <div style={{ width: '50%', minHeight: '100vh', display: isMobile ? 'none' : 'flex', flexDirection: 'column', position: 'relative',  }}>
            <div style={{ 
                flex: 1, 
                position: 'relative', 
                backgroundImage: `url("${Background}")`,
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'left',
            }}>
            
                {showBackLink && (
                <Link to={directory} style={{ 
                    position: 'absolute', 
                    top: '20px', 
                    left: '50px', 
                    color: 'white',
                    textDecoration: 'none',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '10px',
                }}>
                    <img src={Arrow} alt="Back" width='20px' style={{width: '30px', height: 'auto'}}/>
                    <span style={{ marginLeft: '5px', fontFamily: 'Manrope", sans-serif', fontSize: '16px' }}>Back</span>
                </Link>
                )}

                <div style={{position:'absolute', bottom: '130px', left: '0', right: '0' ,display: 'flex', margin: '370px auto 0px', justifyContent: 'space-between', gap: '20px', width: '80%'}}>
                    <AttributeCard 
                        image={pricing}
                        description="Transparent Pricing" 
                    />
                    <AttributeCard 
                        image={verified}
                        description="Verified Vendors" 
                    />
                    <AttributeCard 
                        image={tracking}
                        description="SLA Tracking" 
                    />
                </div>

                <footer style={{ position:'absolute', bottom: '0', left: '0', right: '0', color: 'white', backgroundImage: `url("${FooterBg}")`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', padding: '15px 30px', display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                    <h1 style={{ fontFamily: 'Manrope", sans-serif', fontSize: '25px', fontWeight: '700' }}>Your Personal Concierge. Digitally Delivered.</h1>
                    <p style={{ fontFamily: 'Manrope", sans-serif', fontSize: '15px', marginTop: '10px' }}>Fast, reliable, and secure concierge services at your fingertips.</p>
                </footer>
            </div>
        </div>
        
        <div style={{ width: isMobile ? '100%' : '55%', margin: 'auto' }}>
            {children}
        </div>
    </section>

    )
}